<template>
    <div class="cabinet-content-wrap">
        <SearchAndBasket />

        <section class="cabinet__breadcrumbs">
            <router-link to="/" class="cabinet__breadcrumbs-link"
                >Главная</router-link
            >
            <span class="cabinet__breadcrumbs-arrow">&rsaquo;</span>
            <router-link to="/catalog" class="cabinet__breadcrumbs-link"
                >Каталог</router-link
            >
        </section>

        <div class="cabinet__product-page">
            <h1 class="h1 line">Каталог ювелирных изделий</h1>

            <p v-if="!categories">Loading...</p>

            <template v-else>
                <div class="cabinet__product-section">
                    <div class="cabinet__product-section__title">
                        {{ decorations.Name }}
                    </div>

                    <ul class="cabinet__product-list">
                        <li
                            v-for="type in types"
                            :key="type.TypeID"
                            class="cabinet__product-list__product-item"
                        >
                            <router-link
                                :to="{
                                    name: 'CategoryID',
                                    params: {
                                        id: type.CategoryID,
                                        filter2SubcategoriesFromRoute: type
                                    }
                                }"
                            >
                                <div
                                    class="cabinet__product-list__product-item__img"
                                >
                                    <img
                                        v-if="type.Image"
                                        :src="type.Image"
                                        :alt="type.Name"
                                    />
                                    <img
                                        v-else
                                        src="/img/no-photo.jpg"
                                        :alt="type.Name"
                                    />
                                </div>
                                <h4
                                    class="cabinet__product-list__product-item__title-h4"
                                >
                                    {{ type.Name }}
                                </h4>
                            </router-link>
                        </li>
                    </ul>
                </div>

                <div class="cabinet__product-section">
                    <div class="cabinet__product-section__title">
                        Другие ювелирные изделия
                    </div>

                    <ul class="cabinet__product-list">
                        <li
                            v-for="categorie in categories"
                            :key="categorie.CategoryID"
                            class="cabinet__product-list__product-item"
                        >
                            <router-link
                                :to="{
                                    name: 'CategoryID',
                                    params: { id: categorie.CategoryID }
                                }"
                            >
                                <div
                                    class="cabinet__product-list__product-item__img"
                                >
                                    <img
                                        v-if="categorie.Image"
                                        :src="categorie.Image"
                                        :alt="categorie.Name"
                                    />
                                    <img
                                        v-else
                                        src="/img/no-photo.jpg"
                                        :alt="categorie.Name"
                                    />
                                </div>
                                <h4
                                    class="cabinet__product-list__product-item__title-h4"
                                >
                                    {{ categorie.Name }}
                                </h4>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </template>

            <div class="cabinet__product-page__more">
                <router-link to="/catalog/category/all"
                    >Посмотреть все изделия в каталоге</router-link
                >
            </div>

            <!-- <div class="cabinet__product-page__note">
                <h2 class="h2">SEO текст</h2>
                <p>
                    Выбрать нужное украшение очень просто: достаточно зайти на
                    сайт и заказать в каталоге. Официальный каталог «Русских
                    самоцветов» позволяет сделать это просто и быстро.
                    Информация в нем структурирована, с помощью удобных фильтров
                    можно искать товары по ряду параметров.
                </p>
                <a href="javascript:void(0)" class="h4">Читать дальше</a>
            </div> -->
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import SearchAndBasket from '@/components/Public/SearchAndBasket'

export default {
    name: 'PublicCatalog',
    components: {
        SearchAndBasket
    },
    computed: {
        ...mapGetters({
            publicCategories: 'publicCategories'
        }),
        categories() {
            return this.publicCategories
                ? this.publicCategories.filter(
                      el =>
                          el.types.reduce(
                              (acc, el2) => acc + el2.items_count,
                              0
                          ) && el.CategoryID !== 1
                  )
                : null
        },
        decorations() {
            return this.publicCategories.filter(el => el.CategoryID === 1)[0]
        },
        types() {
            const typesFiltered = this.decorations.types.filter(
                el => el.items_count && el.Image
            )
            const typesList = typesFiltered.map(p =>
                p.Position === null ? { ...p, Position: 99999 } : p
            )
            return typesList.sort((a, b) =>
                a.Position > b.Position ? 1 : b.Position > a.Position ? -1 : 0
            )
        }
    }
}
</script>
